// Fancybox classic
function fancyboxClassic() {

    function isHidden(el) {
        var style = window.getComputedStyle(el);
        return (style.display === 'none')
    }

    function getFocusableElements(els) {
        var focusableElementsString = 'a[href],'
            + ' area[href],'
            + ' input:not([disabled]),'
            + ' select:not([disabled]),'
            + ' textarea:not([disabled]),'
            + ' button:not([disabled]),'
            + ' iframe,'
            + ' object,'
            + ' embed,'
            + ' [tabindex="0"],'
            + ' [contenteditable]';

        return els
            .reduce(function (acc, el) {
                if (!el) {
                    return acc;
                }
                return acc.concat(Array.prototype.slice.call(el.querySelectorAll(focusableElementsString)));
            }, [])
            .filter(function (el) {
                return !isHidden(el);
            });
    }

    function initFocusTrap(event) {
        const focusableElements = getFocusableElements([this.wrap[0], document.getElementById('fancybox-buttons')]);
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        // Listen for the Tab key
        if (event.keyCode === 9) {
            if (focusableElements.length === 1) {
                event.preventDefault();
            }
            // If Shift + Tab
            if (event.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    event.preventDefault();
                    // jump to the last focusable element
                    lastFocusableElement.focus();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    event.preventDefault();
                    // jump to the first focusable element
                    firstFocusableElement.focus();
                }
            }
        }

        if (event.keyCode === 27) {
            $.fancybox.close();
        }
    }

    var focusTrap;

    if ($('.fancybox').length > 0) {
        $('.fancybox').click(function () {
            // Get the clicked link
            lienFocus = this;
        }).fancybox({
            tpl:         {
                closeBtn: '<div class="fancybox-close-wrap"><button type="button" title="' + l10n['closeModalWindow'] + '" class="fancybox-item fancybox-close" ><span class="hover">' + l10n['close'] + '</span> <img src="' + pathImgFancybox + 'close-mobile.png" alt="" /></button></div>',
                next:     '',
                prev:     ''
            },
            // lien actif + focus sur le lien activé
            beforeLoad:  function () {
                focusTrap = initFocusTrap.bind(this);
            },
            afterClose:  function () {
                document.removeEventListener('keydown', focusTrap, true);
                lienFocus.focus();
            },
            afterLoad:   function () {
                this.title = '<p class="captionFancybox">' + this.title + '</p>';
            },
            beforeShow:  function () {
                var dataAlt = this.element.find('img').attr('data-alt');
                this.inner.find('img').attr('alt', dataAlt);
                this.alt = dataAlt;

                var caption = this.element.next('figcaption').text();
                this.title = caption;
            },
            afterShow:   function () {
                // On renvoie le focus dans la popin
                document.addEventListener('keydown', focusTrap, true);
                // Focus first tabbable item
                getFocusableElements([this.wrap[0]])[0].focus();

                $('.fancybox-title').wrap('<div class="fancybox-wrap-title"></div>');
                $('.fancybox-title').wrapInner('<p></p>');
            },
            padding:     15,
            // Supression des effets
            openEffect:  'none',
            closeEffect: 'none',
            nextEffect:  'none',
            prevEffect:  'none',
            // Externalise dans le tpl le title
            helpers:     {
                title: {
                    type: 'outside'
                }
            }
        });
    }
}
